import React, { forwardRef, useEffect, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router';
import PropTypes from 'prop-types';
import track from 'src/utils/analytics';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearNotifications } from 'src/actions/notificationsActions';

const Page = forwardRef(({ title, children, ...rest }, ref) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const sendPageViewEvent = useCallback(() => {
    track.pageview({
      page_path: location.pathname
    });
  }, [location]);

  const notificationsCount = useSelector(state => state.notifications.count);
  const [pageTitle, setPageTitle] = useState(title);

  // User has switched away from the tab
  const onBlur = () => {};
  // User is in the tab
  const onFocus = () => {
    setPageTitle(title);
    dispatch(clearNotifications());
  };
  useEffect(() => {
    window.addEventListener('focus', onFocus);
    onFocus();
    // Specify how to clean up after this effect:
    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
    };
  }, []);

  useEffect(() => {
    sendPageViewEvent();
  }, [sendPageViewEvent]);

  return (
    <div ref={ref} {...rest}>
      <Helmet>
        <title>
          {notificationsCount > 0
            ? `(${notificationsCount}) ` + pageTitle
            : pageTitle}
        </title>
      </Helmet>
      {children}
    </div>
  );
});

Page.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string
};

export default Page;
